import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 14,
	viewBox: "0 0 10 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.33594 2.91634L6.5076 3.74467L5.5801 2.81717V9.33301H4.4251V2.81717L3.4976 3.74467L2.66927 2.91634L5.0026 0.583008L7.33594 2.91634ZM9.66927 5.83301V12.2497C9.66927 12.8913 9.14427 13.4163 8.5026 13.4163H1.5026C0.855104 13.4163 0.335938 12.8913 0.335938 12.2497V5.83301C0.335938 5.18551 0.855104 4.66634 1.5026 4.66634H3.2526V5.83301H1.5026V12.2497H8.5026V5.83301H6.7526V4.66634H8.5026C9.14427 4.66634 9.66927 5.18551 9.66927 5.83301Z",
		fill: "#E8EAED"
	})
});
export { SvgExportIcon as ReactComponent };
